var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.73,
    height: 80
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.73 80V7.24H0V0h21.73v80z",
    fill: "#e8ffa2"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMS43MyIgaGVpZ2h0PSI4MCIgdmlld0JveD0iMCAwIDIxLjczIDgwIj4KICA8cGF0aCBkPSJNMTMuNzMsODBWNy4yNEgwVjBIMjEuNzNWODBaIiBmaWxsPSIjZThmZmEyIi8+Cjwvc3ZnPgo=";
export { SvgNumber as ReactComponent };